var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.965,
    height: 22.006,
    viewBox: "0 0 21.965 22.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mobile",
    d: "M23.131,17.976v3.011A2.008,2.008,0,0,1,20.943,23a19.865,19.865,0,0,1-8.663-3.082,19.574,19.574,0,0,1-6.023-6.023,19.865,19.865,0,0,1-3.082-8.7A2.008,2.008,0,0,1,5.174,3H8.185a2.008,2.008,0,0,1,2.008,1.727,12.888,12.888,0,0,0,.7,2.821,2.008,2.008,0,0,1-.452,2.118L9.169,10.94a16.061,16.061,0,0,0,6.023,6.023l1.275-1.275a2.008,2.008,0,0,1,2.118-.452,12.889,12.889,0,0,0,2.821.7A2.008,2.008,0,0,1,23.131,17.976Z",
    transform: "translate(-2.167 -2)",
    fill: "none",
    stroke: "#4d4e50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.78b407a0e2f2d5bea6629d584fdc0bfa.svg";
export { ForwardRef as ReactComponent };